import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { ChartType } from 'chart.js';
// import { Color, Label } from 'ng2-charts';
import {Subscription} from "rxjs";
import {GadgetFilterDTO} from '@signature-it/ngx-generic/models';
import {GadgetApiService, GadgetsService} from '@signature-it/ngx-generic/services';
import {GenericConfig} from '@signature-it/ngx-generic/config';
declare let _: any;

@Component({
    selector: 'doughnut-chart-gadget',
    templateUrl: './doughnut-charts.gadget.html',
    styleUrls: ['./doughnut-charts.gadget.scss'],
    standalone: false
})
export class DoughnutChartGadget implements OnChanges, OnInit  {

    @Input() data: Array<any>;
    @Input() dataCount: number;
    @Input() title: string;
    @Input() url;
    @Input() filterName: string;
    @Input() dataConfig: object;
    @Input() key: string;
    @Input() type: string;
    @Input() labels: Array<string>;
    @Input() colors: Array<string>;
    filters;
    serverSideFilter;
    gadgetFilterSubscription: Subscription;
    qtyFilters: number = 0;
    loader: boolean = false;
    print: boolean = false;

    doughnutChartLabels;
    doughnutChartData;
    doughnutChartColors = [] ;
    doughnutChartType: ChartType = 'doughnut';
    options: any = {
        legend: { position: 'bottom' },
        plugins: {
            datalabels: {
                display: true,
                offset: 50,
                color: '#FFFFFF',
                // formatter: (value) => {
                //     return value + '%';
                // },
                font: {
                    weight: 'bold'
                }
            },
        }
    }
    constructor(protected gadgetApiSvc: GadgetApiService,
                protected gadgetSvc: GadgetsService,
                private translateSvc: TranslateService) {}

    ngOnInit() {
        this.type = this.type || 'DoughnutChart';
        this.key = this.key || 'doughnut-chart-gadget';
        let gadgetConfig = GenericConfig.gadgets.find(x => x.type === this.type && x.key === this.key);
        this.url = this.url || gadgetConfig.url;
        this.title = this.title || gadgetConfig.title;
        this.dataConfig = this.dataConfig || gadgetConfig.data;
        this.filterName = this.filterName || 'DoughnutChart';
        this.colors = this.colors || gadgetConfig.colors;
        this.labels = this.labels || gadgetConfig.labels;
        this.doughnutChartLabels = this.labels;
        this.doughnutChartColors =  [{backgroundColor: this.colors, },];
        this.qtyFilters = GenericConfig.filterGadget.filter(x => x.name === this.filterName && x.serverSide ).length;
        this.setFilters();
    }

    ngOnChanges(changes: SimpleChanges): void {}

    setFilters() {

        this.gadgetFilterSubscription = this.gadgetSvc.gadgetFilter.subscribe(gadgetFilter => {
            let serverSideFilter = _.filter(gadgetFilter, (filter: any) => filter.name === this.filterName && filter.serverSide);
            if (serverSideFilter) {
                if (!this.serverSideFilter || this.gadgetSvc.compareVal(serverSideFilter, this.serverSideFilter)) {
                    this.serverSideFilter = [];
                    serverSideFilter.forEach(dataFilter => {
                        this.serverSideFilter.push(new GadgetFilterDTO(dataFilter))
                    });
                    if (this.gadgetSvc.hasParams(this.serverSideFilter) && this.serverSideFilter.length == this.qtyFilters) {
                        this.getData();
                    }
                }
                let filters = _.find(gadgetFilter, (filter: any) => filter.name === this.filterName && !filter.serverSide);
                if (filters != this.filters) {
                    this.filters = _.cloneDeep(filters);
                    this.setData();
                }
            }
        });
    }

    getData() {
        this.loader = true;
        this.dataCount = 0;
        let params = this.gadgetSvc.setParams(this.serverSideFilter, this.dataConfig);
        this.gadgetApiSvc.getGadgetData(params , this.url)
            .subscribe(res => {
                this.loader = false;
                this.data = _.chain(res)
                    .groupBy(data => data[0])
                    .value();
                this.setData();
            });
    }

    setData() {
        this.doughnutChartLabels = [];
        this.doughnutChartData =[];
        if (this.data && this.filters.value) {
            for (const property in this.data[this.filters.value]) {
                this.doughnutChartLabels.push(this.translateSvc.instant(this.data[this.filters.value][property][1]))
                this.doughnutChartData.push(parseInt(this.data[this.filters.value][property][2]));
            }
        }

    }

    onPrintNotify() {
        this.print = !this.print;
    }
}
